import * as React from 'react';

function SvgSportsVolleyball(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path fill='none' d='M0 0h24v24H0z' />
			<path
				d='M6 6.73C4.76 8.14 4 9.98 4 12c0 1.1.23 2.14.63 3.1L6 14.31V6.73zM11 4.08c-.25.06-1.98.42-3 1.01v8.07l3-1.73V4.08zM13 4.07v1.58l6.54 3.79c-.97-2.85-3.47-4.99-6.54-5.37zM12 13.15l-6.36 3.67c.64.85 1.46 1.55 2.38 2.09L15 14.89l-3-1.74zM13 7.96v3.46l6.37 3.68c.4-.95.63-1.99.63-3.09l-7-4.05zM10.42 19.84c.51.1 1.04.16 1.58.16 2.6 0 4.9-1.25 6.36-3.17L17 16.04l-6.58 3.8z'
				opacity={0.3}
			/>
			<path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 2.07c3.07.38 5.57 2.52 6.54 5.36L13 5.65V4.07zM8 5.08c1.02-.59 2.75-.95 3-1.01v7.35l-3 1.73V5.08zM4.63 15.1c-.4-.96-.63-2-.63-3.1 0-2.02.76-3.86 2-5.27v7.58l-1.37.79zm1.01 1.73L12 13.15l3 1.73-6.98 4.03a7.794 7.794 0 01-2.38-2.08zM12 20c-.54 0-1.07-.06-1.58-.16l6.58-3.8 1.36.78C16.9 18.75 14.6 20 12 20zm1-8.58V7.96l7 4.05c0 1.1-.23 2.14-.63 3.09L13 11.42z' />
		</svg>
	);
}

export default SvgSportsVolleyball;
